import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly label: string;
  readonly active?: boolean;
  readonly children: ReactNode;
}

export function IconButton({ label, active = false, children, className = '', ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className={`group relative ${active ? 'tool-active' : ''} ${className || 'hive-icon-button'}`}
      {...props}
    >
      {children}
      <span className="pointer-events-none absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 whitespace-nowrap rounded bg-hive-ink px-2 py-1 text-xs font-semibold text-hive-cream opacity-0 shadow-soft transition group-hover:opacity-100">
        {label}
      </span>
    </button>
  );
}
